import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Reseason from "../../../assets/ImageEditing/images/Re_season.jpg";
import Relight from "../../../assets/ImageEditing/images/relight.jpg";
import Rrestyle from "../../../assets/ImageEditing/images/restyle.jpg";
import SketchImage from "../../../assets/ImageEditing/images/sketch to image.jpg";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";

const StyleAtmosphere = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageEditing.api" });
	const navigate = useNavigate();

	const rightActions = (
		<>
			<BriaButton buttonType="secondarySmall" onClick={() => navigate(RouterConstants.ACCOUNT_IFRAMES.fullPath)}>
				{t("headerButtons.configureIframe")}
			</BriaButton>
			<BriaButton
				buttonType="secondarySmall"
				onClick={() => navigate(RouterConstants.IMAGE_EDITING.IMAGE.DEMO.fullPath)}
			>
				{t("headerButtons.playground")}
			</BriaButton>
		</>
	);

	const openDocs = (link: string) => window.open(link, "_blank");

	const styleAtmosphereCards: ConsoleAPICardProps[] = [
		{
			image: Rrestyle,
			header: t("cards.restyle.header"),
			description: t("cards.restyle.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.RESTYLE.DOCS)}>
					{t("cards.restyle.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.RESTYLE.DOCS),
		},
		{
			image: Relight,
			header: t("cards.relight.header"),
			description: t("cards.relight.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.RELIGHT.DOCS)}>
					{t("cards.relight.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.RELIGHT.DOCS),
		},
		{
			image: Reseason,
			header: t("cards.reseason.header"),
			description: t("cards.reseason.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.RESEASON.DOCS)}>
					{t("cards.reseason.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.RESEASON.DOCS),
		},
		{
			image: SketchImage,
			header: t("cards.sketchToImage.header"),
			description: t("cards.sketchToImage.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.IMAGE_EDITING.SKETCH_TO_IMAGE.DOCS)}
				>
					{t("cards.sketchToImage.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.SKETCH_TO_IMAGE.DOCS),
		},
	];

	return (
		<ConsoleAPILayout rightActions={rightActions} showIntegrationKeyButton>
			<ConsoleAPICards cards={styleAtmosphereCards} />
		</ConsoleAPILayout>
	);
};

export default observer(StyleAtmosphere);
